/* ELVARA - pre-order badge on the product page and on tracker pages.

   The collection card already shows a gold "Pre-Order" pill, but opening the
   product lost it: the product page only had a text note further down the form.
   This puts the same pill back on the product image, and adds one to tracker
   pages when the shopper picks a pre-order band.

   It does not invent pre-order state - it reads the two places that already
   record it, so there is still one place to change the rule:
     - [data-elv-pre-variants] : per-variant JSON the product form emits. The
       authority for "is THIS product/variant pre-order".
     - .wbp-band[data-pre="true"].is-sel : the band picker's own flag on the
       band the shopper currently has selected.

   Those mean different things, so the label differs. On a tracker page the
   device is in stock and the BAND is not - a bare "Pre-Order" over the tracker
   image would tell the customer the wrong thing about what they are buying.

   NOTE: the picker's own .elv-preorder-note stays hidden even when a pre-order
   band is selected (aria-pressed and is-sel get set, the note does not unhide).
   That is a separate pre-existing bug in the picker. This badge deliberately
   reads data-pre rather than the note's visibility so it is correct regardless,
   but the note itself still needs fixing.

   Everything recomputes from live DOM on every variant/band change - nothing
   here is a static snapshot. */
(function () {
  'use strict';

  var isArabic = (document.documentElement.lang || '').indexOf('ar') === 0;
  var LABEL = {
    product: isArabic ? 'طلب مسبق' : 'Pre-Order',
    band: isArabic ? 'السوار بطلب مسبق' : 'Pre-Order band'
  };
  var ID = 'elvPreorderBadge';

  /* Is the variant the shopper currently has selected a pre-order one? */
  function productIsPre() {
    var data = document.querySelector('[data-elv-pre-variants]');
    if (!data) return false;

    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return false; }
    if (!variants.length) return false;

    var idEl = document.querySelector('.product-variant-id');
    var id = idEl ? parseInt(idEl.value, 10) : 0;
    if (id) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return !!variants[i].pre;
      }
    }
    /* Single-variant products have exactly one entry and no picker. */
    return variants.length === 1 ? !!variants[0].pre : false;
  }

  function preBandSelected() {
    return !!document.querySelector('.wbp-band.is-sel[data-pre="true"]');
  }

  function noteVisible() {
    var n = document.querySelector('.elv-preorder-note');
    if (!n || n.hasAttribute('hidden')) return false;
    return getComputedStyle(n).display !== 'none';
  }

  function currentState() {
    if (productIsPre()) return 'product';
    if (preBandSelected()) return 'band';
    if (noteVisible()) return 'band';
    return null;
  }

  /* Anchor to the media ITEM, not to .media itself. Dawn stretches every direct
     child of .media to fill it:
       .media > :not(.zoom):not(.deferred-media__poster-button)
         { position:absolute; top:0; left:0; width:100%; height:100% }
     A badge dropped inside .media therefore became a 548x548 gold square. The
     explicit top/width/height resets below are belt-and-braces for the fallback
     branch, which can still land inside a .media element. */
  function host() {
    return document.querySelector('.product__media-wrapper .product__media-item.is-active')
      || document.querySelector('.product__media-wrapper .product__media-item')
      || document.querySelector('.product__media-wrapper');
  }

  function render(state) {
    var badge = document.getElementById(ID);

    if (!state) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      var h = host();
      if (!h) return;
      if (getComputedStyle(h).position === 'static') h.style.position = 'relative';

      badge = document.createElement('span');
      badge.id = ID;
      badge.className = 'badge elv-preorder-badge';
      badge.setAttribute(
        'style',
        'position:absolute;z-index:3;top:auto;right:auto;' +
        'bottom:1.2rem;inset-inline-start:1.2rem;' +
        'width:auto;height:auto;max-width:none;' +
        'background:#c9a24b;color:#1a1a1a;border:1px solid #c9a24b;' +
        'border-radius:var(--badge-corner-radius,4rem);padding:0.5rem 1.2rem;' +
        'font-size:1.2rem;line-height:1.2;font-weight:600;letter-spacing:0.02em;' +
        'white-space:nowrap;pointer-events:none;'
      );
      h.appendChild(badge);
    }

    var text = LABEL[state];
    if (badge.textContent !== text) badge.textContent = text;
  }

  var pending = null;
  function sync() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () { render(currentState()); }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }

  /* Dawn replaces the whole product form on a variant change, and the band
     picker flips is-sel on click - watch both. */
  document.addEventListener('change', sync, true);
  document.addEventListener('click', sync, true);

  new MutationObserver(sync).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden', 'style', 'class', 'value', 'aria-pressed']
  });
})();
